import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type UpsertSectionTemplateRequest as SchemaUpsertSectionTemplateRequest } from '../schemas/UpsertSectionTemplateRequest';
import { type UpsertSectionTemplateResponse as SchemaUpsertSectionTemplateResponse } from '../schemas/UpsertSectionTemplateResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags SectionTemplate
 */
export const CreateSectionTemplateContentType = 'application/json' as const;
export type CreateSectionTemplateRequest = SchemaUpsertSectionTemplateRequest;
export type CreateSectionTemplateResponses = LinkCommonErrorResponses & {
    /**
     * @description Section template created successfully
     */
    '200': {
        'application/json': SchemaUpsertSectionTemplateResponse;
    };
};
export type CreateSectionTemplateResponseSuccess = CreateSectionTemplateResponses['200']['application/json'];
export type CreateSectionTemplateSearchParams = undefined;
export type CreateSectionTemplatePathParameters = undefined;
export const CreateSectionTemplateUrl = '/section_template' as const;
export const CreateSectionTemplateMethod = 'POST' as const;
export const getCreateSectionTemplateUrl = (_params?: CreateSectionTemplatePathParameters) => CreateSectionTemplateUrl;
